import { ConvexError } from "convex/values";

export const LIMITS = {
  fileBytes: 2 * 1024 * 1024,
  pages: 50,
  characters: 100_000,
  contextCharacters: 24_000,
  selectedDocuments: 3,
  extractionMs: 30_000,
  ttlMs: 24 * 60 * 60 * 1000,
} as const;

export type TextUnit = { number: number; text: string };

export function redactText(value: string) {
  return value
    .replace(/\b\d{3}[. ]?\d{3}[. ]?\d{3}[- ]?\d{2}\b/g, "[CPF removido]")
    .replace(/\b\d{2}[. ]?\d{3}[. ]?\d{3}[/ ]?\d{4}[- ]?\d{2}\b/g, "[CNPJ removido]")
    .replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi, "[e-mail removido]")
    .replace(/(?:\+55\s*)?(?:\(\d{2}\)|\b\d{2})\s*9?\d{4}[- ]?\d{4}\b/g, "[telefone removido]")
    .replace(
      /\b(?:rua|avenida|av\.|estrada|rodovia|travessa|alameda)\s+[^\n;]{1,140}/gi,
      "[endereço removido]",
    );
}

export function selectUnits(units: TextUnit[], start?: number, end?: number) {
  const first = start ?? 1;
  const last = end ?? units.length;
  if (
    !Number.isInteger(first) ||
    !Number.isInteger(last) ||
    first < 1 ||
    last < first ||
    last > units.length
  ) {
    throw new ConvexError("Informe um intervalo válido de páginas ou linhas.");
  }
  return units.filter((unit) => unit.number >= first && unit.number <= last);
}

function normalize(value: string) {
  return value.normalize("NFKC").replace(/\s+/g, " ").trim();
}

export function verifyStatements(
  statements: Array<{
    text: string;
    citations: Array<{ source: string; unit: number; quote: string }>;
  }>,
  sources: Array<{ source: string; units: TextUnit[] }>,
) {
  if (statements.length === 0 || statements.length > 12) return false;
  return statements.every(
    (statement) =>
      statement.citations.length > 0 &&
      statement.citations.length <= 5 &&
      statement.citations.every((citation) => {
        const unit = sources
          .find((source) => source.source === citation.source)
          ?.units.find((entry) => entry.number === citation.unit);
        const quote = normalize(citation.quote);
        return unit !== undefined && quote.length >= 8 && normalize(unit.text).includes(quote);
      }),
  );
}
